export const isBottom = el => (el ? el.getBoundingClientRect().bottom <= window.innerHeight : false);

export const isTop = el => (el ? el.getBoundingClientRect().top <= window.innerHeight : false);
